import styled from '@emotion/styled';

export const UploadButtonText = styled.span`
  margin-left: 6px;
`;
